import { ServiceItem } from '@shared/serviceitem';

export const serviceItems: ServiceItem[] = [
	{
		label: 'AciesInsights',
		link: 'insights/reports',
		enabled: true,
		showInServiceMenu: true,
		permission: 'insights:UserReportGet',
		forceTranslateKey: 'insights.service.label',
	},
	{
		label: 'Masterdata',
		link: 'masterdata/registers/T_KonstSymbol',
		enabled: true,
		permission: 'drawing:SymbolGetList|cutting:RackList|palletising:PalletGet|racking:RackList',
		showInServiceMenu: true,
		forceTranslateKey: 'masterdata.service.label',
	},
	{
		label: 'Sales',
		link: 'sales/orders',
		enabled: true,
		permission: '',
		forceTranslateKey: 'sales.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'AciesMES',
		link: 'mes',
		enabled: true,
		permission: 'mes:EmployeeGet',
		forceTranslateKey: 'mes.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'Docs',
		link: 'docs/templates',
		enabled: true,
		permission: 'docs:TemplateCreate',
		forceTranslateKey: 'docs.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'Print',
		// Land on the bare group route; PrintLandingGuard redirects to the first Print sidebar
		// page the user actually has permission for. This avoids hardcoding a specific child as
		// the default landing page as more Print pages are added.
		link: 'print',
		enabled: true,
		permission: 'print:PrinterGet|print:LabelPost|print:LabelListGet|print:LabelExecutionList',
		forceTranslateKey: 'print.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'Configurator',
		link: 'sales/configurator',
		enabled: false,
		permission: '',
		forceTranslateKey: 'sales.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'Calculations',
		link: 'calculations/matrices',
		enabled: true,
		permission: 'matrix:CalculationMatrixGetList',
		forceTranslateKey: 'calculations.service.label',
		showInServiceMenu: true,
	},
	{
		label: 'Administration',
		// Land on the bare group route; AdminLandingGuard redirects to the first admin page the
		// user actually has permission for (the previous hardcoded /ipsettings landing bounced any
		// admin without iam:OrganizationsAccountsPut — e.g. SCIM-only or sync-monitoring-only — to /core).
		link: 'administration',
		enabled: true,
		permission: 'iam:OrganizationsAccountsPut|iam:FlagsVariantPut|drawing:StylingGetDownloadUrl|iam:ScimUsersGetList|one:EnvironmentGet',
		forceTranslateKey: 'administration.service.label',
		showInServiceMenu: false,
	},
	{
		label: 'Setup',
		link: 'setup/featureflagsadmin',
		enabled: true,
		permission: 'iam:OrganizationsPut',
		forceTranslateKey: 'setup.label',
		showInServiceMenu: false,
	},
	{
		label: 'FeatureFlagsAdmin',
		link: 'setup/featureflagsadmin',
		enabled: true,
		permission: 'iam:FlagsPut',
		forceTranslateKey: 'setup.sidebar.featureflagsadmin',
		showInServiceMenu: false,
	},
];
